export { default } from './FooterV1';
